/**
 * @typedef {string} PaginationCursor
 * @typedef {string} Timestamp
 * @typedef {'collection'|'category'|'app'} DisplayType
 * @typedef {Object} SearchQuery
 *
 * @typedef {{
 *   name: string | SearchQuery,
 *   id: string | SearchQuery
 * }} ProductFilter
 *
 * @typedef {{
 *   id: string,
 *   price: string,
 *   brandId: string,
 *   description: string,
 *   campaign: null,
 *   name: string,
 *   over18: boolean,
 *   integration: string,
 *   redemptionInstructions: string,
 *   image: string,
 *   locationText: string,
 *   weight: 99463345,
 *   recipientDescription: string,
 *   openGraphImage: string,
 *   active: boolean,
 *   handlingFee: number,
 *   supplierPrice: number,
 *   senderPrice: number,
 *   vatVoucherType: {"SPV"|"MPV"},
 *   vat: number|null,
 *   merchandisingTitle: string,
 *   merchandisingImage: string,
 *   merchandisingSubtitle: string,
 *   merchandisingImageDetailed: string,
 *   images: string[]|null,
 *   deliveryTimescale: string|null,
 *   createdAt: Timestamp,
 *   updatedAt: Timestamp,
 *   labelIds: string[],
 *   tagIds: string[],
 *   taxonomyIds: string[]
 * }} Product
 *
 * @typedef {{
 *   data: Product[]
 * }} ProductSearchResponse
 */

import { prop } from 'ramda';
import { urls } from '../config.js';
import withAxios from '../utils/with-axios';
import v3Generic from './v3-generic';
var _v3Generic = v3Generic('products', 'sql'),
  search = _v3Generic.search,
  single = _v3Generic.single;

/**
 * Takes an array of brands which the user can view, and filters out
 * any which are not purchaseable.
 *
 * @param {array} visibleIds
 * @returns
 */
var purchasePermissions = function purchasePermissions(axios, visibleIds) {
  return axios.post(urls.apiV2('/permissions/apply'), {
    permissionType: 'product-purchase',
    resourceIds: visibleIds
  }).then(prop('data'));
};

/**
 * Takes an array of brands which the user can view, and filters out
 * any which are not purchaseable.
 *
 * @param {array} visibleIds
 * @returns
 */
var segments = function segments(axios, productId) {
  return axios.get(urls.apiV2("/products/".concat(productId, "/segments"))).then(prop('data'));
};
export default {
  /**
   *
   * @param {Object} [optional] $axios
   * @param {import('./v3-generic').SqlSearchOptions} options
   *
   * @returns {Promise<ProductSearchResponse>} Unresolved Promise from the API.
   */
  search: search,
  /**
   * Fetch a singular taxonomy by ID
   *
   * @param {Object} [optional] $axios Axios instance.
   * @param {String} id
   *
   * @returns {Promise<Product>} Unresolved Promise from the API.
   */
  single: single,
  /**
   * Takes an array of products which the user can view, and filters out
   * any which are not purchaseable.
   *
   * @param {Object} [optional] $axios
   * @param {string[]} visibleIds
   * @returns {Promise<{data: string[]}>}
   */
  purchasePermissions: withAxios(purchasePermissions),
  /**
   * Takes an array of products which the user can view, and filters out
   * any which are not purchaseable.
   *
   * @param {Object} [optional] $axios
   * @param {string[]} visibleIds
   * @returns {Promise<{data: string[]}>}
   */
  segments: withAxios(segments)
};